import React, { ReactNode } from "react";

interface TraceabilitySummaryBoxProps {
  label: string;
  children: ReactNode;
}

export default function TraceabilitySummaryBox({
  label,
  children,
}: TraceabilitySummaryBoxProps) {
  return (
    <div role="group" aria-label={label} className="bg-gray-50 rounded-lg p-3">
      <div className="text-sm font-medium text-gray-600 mb-1">{label}</div>
      <div className="text-xl font-semibold text-gray-900">{children}</div>
    </div>
  );
}
